/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createCustomer } from '../fn/customer/create-customer';
import { CreateCustomer$Params } from '../fn/customer/create-customer';
import { CustomerResponse } from '../models/customer-response';
import { deleteCustomer } from '../fn/customer/delete-customer';
import { DeleteCustomer$Params } from '../fn/customer/delete-customer';
import { getCustomers } from '../fn/customer/get-customers';
import { GetCustomers$Params } from '../fn/customer/get-customers';
import { setActiveCustomer_2 } from '../fn/customer/set-active-customer-2';
import { SetActiveCustomer_2$Params } from '../fn/customer/set-active-customer-2';
import { updateCustomer } from '../fn/customer/update-customer';
import { UpdateCustomer$Params } from '../fn/customer/update-customer';

@Injectable({ providedIn: 'root' })
export class CustomerService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCustomers()` */
  static readonly GetCustomersPath = '/api/customer';

  /**
   * Get Customers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomers$Response(params?: GetCustomers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerResponse>>> {
    return getCustomers(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Customers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomers(params?: GetCustomers$Params, context?: HttpContext): Observable<Array<CustomerResponse>> {
    return this.getCustomers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerResponse>>): Array<CustomerResponse> => r.body)
    );
  }

  /** Path part for operation `createCustomer()` */
  static readonly CreateCustomerPath = '/api/customer';

  /**
   * Create Customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCustomer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCustomer$Response(params: CreateCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCustomer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCustomer(params: CreateCustomer$Params, context?: HttpContext): Observable<void> {
    return this.createCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateCustomer()` */
  static readonly UpdateCustomerPath = '/api/customer/{customerId}';

  /**
   * Update Customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCustomer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomer$Response(params: UpdateCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCustomer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomer(params: UpdateCustomer$Params, context?: HttpContext): Observable<void> {
    return this.updateCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteCustomer()` */
  static readonly DeleteCustomerPath = '/api/customer/{customerId}';

  /**
   * Delete Customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCustomer()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCustomer$Response(params: DeleteCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCustomer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCustomer(params: DeleteCustomer$Params, context?: HttpContext): Observable<void> {
    return this.deleteCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setActiveCustomer_2()` */
  static readonly SetActiveCustomer_2Path = '/api/customer/{customerId}/setactive={isActive}';

  /**
   * Set Active Customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setActiveCustomer_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  setActiveCustomer_2$Response(params: SetActiveCustomer_2$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerResponse>> {
    return setActiveCustomer_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Set Active Customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setActiveCustomer_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setActiveCustomer_2(params: SetActiveCustomer_2$Params, context?: HttpContext): Observable<CustomerResponse> {
    return this.setActiveCustomer_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerResponse>): CustomerResponse => r.body)
    );
  }

}
